__turbopack_context__.v({
  "backHome": "Error404-module__wPAzeq__backHome",
  "bookCategory": "Error404-module__wPAzeq__bookCategory",
  "bookContainer": "Error404-module__wPAzeq__bookContainer",
  "bookImage": "Error404-module__wPAzeq__bookImage",
  "container": "Error404-module__wPAzeq__container",
  "header": "Error404-module__wPAzeq__header",
  "search": "Error404-module__wPAzeq__search",
  "searchBox": "Error404-module__wPAzeq__searchBox",
  "searchLabel": "Error404-module__wPAzeq__searchLabel",
  "subtitle": "Error404-module__wPAzeq__subtitle",
  "title": "Error404-module__wPAzeq__title",
});
